import { createReducer, on } from "@ngrx/store";
import { errorModel } from "@sports-models/index";
import * as SportsbookActions from "../sportsbook.actions";

export const initialState: errorModel = {
  errorQueue: [],
  errorHistory: [],
};

export const SportsbookErrorReducer = createReducer(
  initialState,
  on(SportsbookActions.consumeSportsError, (state) => {
    const newErrorHistory = [...state.errorHistory];
    const newErrorQueue = [...state.errorQueue];
    if (state.errorQueue.length) {
      const errorToConsume = newErrorQueue.shift();
      newErrorHistory.push(errorToConsume);
    }
    return {
      ...state,
      errorQueue: newErrorQueue,
      errorHistory: newErrorHistory,
    };
  }),
  on(SportsbookActions.flushSportsErrorQueue, (state) => {
    const newErrorHistory = [...state.errorHistory];
    const newErrorQueue = [...state.errorQueue];
    if (newErrorQueue.length) {
      const errorToConsume = newErrorQueue.shift();
      newErrorHistory.push(errorToConsume);
      while (newErrorQueue.length) {
        const errorToConsume = newErrorQueue.shift();
        newErrorHistory.push({ ...errorToConsume, discarted: true });
      }
    }
    return {
      ...state,
      errorQueue: newErrorQueue,
      errorHistory: newErrorHistory,
    };
  }),
  on(SportsbookActions.setSportsError, (state, { type, ...payload }) => {
    const newErrorQueue = [...state.errorQueue];
    const notExistsInQueue =
      state.errorQueue.findIndex((item) => {
        return item.errorCode === payload.errorCode && item?.errorMessage === payload?.errorMessage;
      }) === -1;
    if (payload.errorCode && notExistsInQueue) {
      newErrorQueue.push(payload);
    }
    return {
      ...state,
      errorQueue: newErrorQueue,
      errorHistory: state.errorHistory,
    };
  }),
);
